export default __webpack_public_path__ + "static/media/React.b545233a.svg";